import { Component, Input, ViewChild, ElementRef, OnInit, OnDestroy, OnChanges, EventEmitter, Output } from '@angular/core';
// import { CommonModule } from '@angular/common';
import { AppPlatformService } from 'src/app/service/platform/app-platform.service';
import { ToastService } from 'src/app/service/toast-service/toast.service';

@Component({
  selector: 'app-custom-video-player',
  templateUrl: './custom-video-player.component.html',
  styleUrls: ['./custom-video-player.component.scss'],
})
export class CustomVideoPlayerComponent implements OnInit, OnDestroy, OnChanges {
  @ViewChild('videoElement', { static: false }) videoElement!: ElementRef<HTMLVideoElement>;
  @Input() videoSrc: string = '';
  @Input() posterSrc: string = '';
  @Input() videoId: string = 'video-player';
  @Input() savedCurrentTime: number = 0;
  @Input() reviewAllIsRequired: boolean = false;
  @Output() videoEnded = new EventEmitter<{ currentTime: any }>();
  @Output() videoPaused = new EventEmitter<number>();
  @Output() videoPlaying = new EventEmitter<number>();
  @Output() isVertical = new EventEmitter<boolean>();
  @Output() videoWWillEnd = new EventEmitter<boolean>();


  isPlaying: boolean = false;
  hasSetInitialTime: boolean = false;
  currentTime: number = 0;
  duration: number = 0;
  volume: number = 1;
  isMuted: boolean = false;
  showControls: boolean = true;
  isfullscren: boolean = false;
  progress: number = 0;
  playbackSpeed: number = 1;
  showSpeedMenu: boolean = false;
  speedOptions: number[] = [0.5, 0.75, 1, 1.25, 1.5, 2];

  private hideControlsTimeout: any;
  showPlayPauseIcon: boolean = false;
  playPauseIconType: 'play' | 'pause' = 'play';
  private iconTimeout: any;
  showVolumeBar: boolean = false;
  private hideTimeout?: any;
  showPlayControls: boolean = true;
  private readonly SEEK_TOLERANCE = 0.05;

  constructor(private appPlatform: AppPlatformService, private toastService: ToastService,) { }

  ngOnInit() {
    // Escuchar cuando cambia el estado de fullscreen
    document.addEventListener('fullscreenchange', this.onFullscreenChange.bind(this));
    document.addEventListener('webkitfullscreenchange', this.onFullscreenChange.bind(this));

    setTimeout(() => {
      if (this.videoElement?.nativeElement) {
        const video = this.videoElement.nativeElement;

        // Listeners específicos para iOS fullscreen
        video.addEventListener('webkitbeginfullscreen', this.onEnterFullscreen.bind(this));
        video.addEventListener('webkitendfullscreen', this.onExitFullscreen.bind(this));

        // Listener para sincronizar el estado de play/pause
        video.addEventListener('play', this.onVideoPlay.bind(this));
        video.addEventListener('pause', this.onVideoPause.bind(this));
      }
    }, 100);
  }

  ngOnChanges(changes): void {
    // console.log("ngOnChanges savedCurrentTime::", this.savedCurrentTime)

    // Detectar cuando cambia videoSrc
    if ((changes['videoSrc'] && !changes['videoSrc'].firstChange)) {
      this.resetPlayer();
    }
    // if (changes['videoSrc'] && !changes['videoSrc'].firstChange) {
    //   this.resetPlayer();
    // }
  }

  ngOnDestroy(): void {
    if (this.hideControlsTimeout) {
      clearTimeout(this.hideControlsTimeout);
    };
    if (this.iconTimeout) {
      clearTimeout(this.iconTimeout);
    };

    document.removeEventListener('fullscreenchange', this.onFullscreenChange.bind(this));
    document.removeEventListener('webkitfullscreenchange', this.onFullscreenChange.bind(this));

    if (this.videoElement?.nativeElement) {
      const video = this.videoElement.nativeElement;
      video.removeEventListener('webkitbeginfullscreen', this.onEnterFullscreen.bind(this));
      video.removeEventListener('webkitendfullscreen', this.onExitFullscreen.bind(this));
      video.removeEventListener('play', this.onVideoPlay.bind(this));
      video.removeEventListener('pause', this.onVideoPause.bind(this));
    }
  }

  private resetPlayer(): void {
    // Resetear el estado del reproductor
    this.isPlaying = false;
    this.currentTime = 0;
    this.progress = 0;
    this.duration = 0;

    // Resetear el video si ya existe
    if (this.videoElement?.nativeElement) {
      const video = this.videoElement.nativeElement;
      video.pause();
      video.currentTime = 0;
      video.load();
    }
  }

  progressBarChange(event) {
    this.onMouseMove();
    // console.log('ionChange emitted value::', event.detail.value, this.reviewAllIsRequired);
    const time = parseFloat(event.detail.value || 0);
    const video = this.videoElement.nativeElement;
    if (this.reviewAllIsRequired) {
      // Disallow forward seeking: only allow seek if the requested time <= currentTime (rewind)
      if (time <= (this.currentTime + this.SEEK_TOLERANCE)) {
        video.currentTime = time;
        this.currentTime = time;
      } else {
        // Block forward seek — restore slider to currentTime
        // This will sync slider bound [value]="currentTime" back to the actual time
        this.currentTime = video.currentTime;
        if (!this.isPlaying) {
          video.play();
          this.isPlaying = !this.isPlaying;
          this.videoPlaying.emit();
        }
      }
    } else {
      video.currentTime = time;
      this.currentTime = time;
    }
  }

  onRangeInput(event: any) {
    const time = parseFloat(event.detail?.value || 0);
    const video = this.videoElement.nativeElement;
    if (this.reviewAllIsRequired) {
      if (time <= (this.currentTime + this.SEEK_TOLERANCE)) {
        // allow rewinding via drag
        this.currentTime = time;
      } else {
        // block forward dragging: keep slider at current time
        this.currentTime = video.currentTime;
      }
    } else {
      this.currentTime = time;
    }
  }


  onFullscreenChange00(): void {
    if (!document.fullscreenElement) {
      this.isfullscren = false;
    } else {
      this.isfullscren = true;
    }
  }

  onFullscreenChange(): void {
    const doc: any = document;
    if (!document.fullscreenElement && !doc.webkitFullscreenElement) {
      this.isfullscren = false;
    } else {
      this.isfullscren = true;
    }
  }

  onMouseEnter(): void {
    // console.log("onMouseEnter!")
    this.showControls = true;
    this.clearHideTimeout();
  }

  onMouseLeave(): void {
    // console.log("onMouseLeave!")
    this.showControls = false;
    this.clearHideTimeout();
  }

  onMouseMove(): void {
    // console.log("onMouseMove! isPlaying", this.isPlaying )
    this.showControls = true;
    this.clearHideTimeout();

    this.hideControlsTimeout = setTimeout(() => {
      // if (this.isPlaying) {
      this.showControls = false;
      // }
    }, 2500);
  }

  private clearHideTimeout(): void {
    if (this.hideControlsTimeout) {
      clearTimeout(this.hideControlsTimeout);
    }
  }

  // togglePlay(event): void {
  //   event.stopPropagation();
  //   const video = this.videoElement.nativeElement;
  //   if (video.paused) {
  //     video.play();
  //     this.isPlaying = true;
  //      this.showTemporaryIcon('play');
  //   } else {
  //     video.pause();
  //     this.isPlaying = false;
  //     this.showTemporaryIcon('pause');
  //   }
  // }

  togglePlayPause(event: MouseEvent): void {
    event.stopPropagation();
    const video = this.videoElement.nativeElement;
    if (this.isPlaying) {
      video.pause();
      const currentTime = this.videoElement.nativeElement.currentTime;
      this.videoPaused.emit(currentTime);
      // this.clearHideTimeout2();
      // this.showTemporaryIcon('pause');
      // this.showPlayControls = true;
    } else {
      video.play();
      this.videoPlaying.emit();
      // this.showTemporaryIcon('play');
      // this.hideControls();
    }
    this.isPlaying = !this.isPlaying;
  }

  // private showTemporaryIcon(type: 'play' | 'pause'): void {
  //   if (this.iconTimeout) {
  //     clearTimeout(this.iconTimeout);
  //   }

  //   // Mostrar el icono
  //   this.playPauseIconType = type;
  //   this.showPlayPauseIcon = true;

  //   // Ocultar después de 500ms
  //   this.iconTimeout = setTimeout(() => {
  //     this.showPlayPauseIcon = false;
  //   }, 700);
  // }



  onTimeUpdate(): void {
    const video = this.videoElement.nativeElement;
    this.currentTime = video.currentTime;
    this.progress = (video.currentTime / video.duration) * 100;
    //Less than 3 seconds to go.
    if (video.currentTime > video.duration - 3) {
      this.videoWWillEnd.emit(true);
    };
  }

  onLoadedMetadata(): void {
    const video = this.videoElement.nativeElement;
    this.duration = video.duration;
    this.setInitialTime();
    this.checkVideoOrientation(video);
  }

  checkVideoOrientation(video) {
    // const video = this.videoElement.nativeElement;
    const width = video.videoWidth;
    const height = video.videoHeight;
    const aspectRatio = width / height;


    const isVertical = aspectRatio < 0.8;
    this.isVertical.emit(isVertical);
  }

  private setInitialTime() {
    if (!this.hasSetInitialTime && this.savedCurrentTime > 0) {
      const video = this.videoElement.nativeElement;

      // Asegurarse de que el video esté listo
      if (video.readyState >= 2) { // HAVE_CURRENT_DATA o superior
        video.currentTime = this.savedCurrentTime;
        this.hasSetInitialTime = true;
        // console.log(`Video iniciado en: ${this.savedCurrentTime} segundos`);
      }
    }
  }

  seekVideo(event: MouseEvent): void {
    const progressBar = event.currentTarget as HTMLElement;
    const rect = progressBar.getBoundingClientRect();
    const pos = (event.clientX - rect.left) / rect.width;
    const video = this.videoElement.nativeElement;
    video.currentTime = pos * video.duration;
  }

  formatTime(seconds: number): string {
    if (isNaN(seconds)) return '0:00';

    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const secs = Math.floor(seconds % 60);

    if (hours > 0) {
      return `${hours}:${minutes.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
    }
    return `${minutes}:${secs.toString().padStart(2, '0')}`;
  }

  changeVolume(event: Event): void {
    this.onMouseMove();
    const input = event.target as HTMLInputElement;
    this.volume = parseFloat(input.value);
    const video = this.videoElement.nativeElement;
    video.volume = this.volume;
    this.isMuted = this.volume === 0;
  }

  toggleMute(): void {
    this.onMouseMove();
    const video = this.videoElement.nativeElement;
    if (this.isMuted) {
      video.volume = this.volume || 0.5;
      this.volume = video.volume;
      this.isMuted = false;
    } else {
      video.volume = 0;
      this.isMuted = true;
    }
  }


  toggleFullscreen(): void {
    this.onMouseMove();
    const video = this.videoElement.nativeElement as any;
    const doc: any = document;

    try {
      // Verificar si ya está en fullscreen
      if (document.fullscreenElement || doc.webkitFullscreenElement) {
        // Salir de fullscreen
        if (doc.exitFullscreen) {
          doc.exitFullscreen();
        } else if (doc.webkitExitFullscreen) {
          doc.webkitExitFullscreen();
        }
        this.isfullscren = false;
      } else {
        // Entrar a fullscreen
        if (this.appPlatform.isIosHibridApp()) {
          // SOLO para iOS: usar webkitEnterFullscreen en el video
          if (video.webkitEnterFullscreen) {
            video.webkitEnterFullscreen();
            this.isfullscren = true;
          }
        } else {
          // Para Web y Android: usar requestFullscreen en el contenedor
          const container = video.parentElement;
          if (container?.requestFullscreen) {
            container.requestFullscreen();
            this.isfullscren = true;
          }
        }
      }
    } catch (error) {
      console.error('Error al cambiar modo fullscreen:', error);
    }
  }

  togglePictureInPicture(): void {
    this.onMouseMove();
    const video = this.videoElement.nativeElement as any;

    try {
      if (this.appPlatform.isIosHibridApp()) {
        // SOLO para iOS: usar webkitSetPresentationMode
        if (video.webkitSetPresentationMode) {
          if (video.webkitPresentationMode === 'picture-in-picture') {
            video.webkitSetPresentationMode('inline');
          } else {
            video.webkitSetPresentationMode('picture-in-picture');
          }
        } else {
          console.warn('Picture-in-Picture no disponible en este dispositivo iOS');
          this.toastService.presentToast("informative", "Picture-in-Picture no disponible en este dispositivo iOS", 3000,"top" );
        }
      } else {
        // Para Web y Android: API estándar con verificación de soporte
        if (document.pictureInPictureEnabled) {
          if (document.pictureInPictureElement) {
            document.exitPictureInPicture();
          } else {
            video.requestPictureInPicture();
          }
        } else {
          console.warn('Picture-in-Picture no está disponible en este entorno de Android.');
          this.toastService.presentToast("informative", "Picture-in-Picture no está disponible en este dispositivo Android.", 3000,"top" );
        }
      }
    } catch (error) {
      console.error('Error al activar Picture-in-Picture:', error);
    }
  }

  getVolumeIcon(): string {
    if (this.isMuted || this.volume === 0) return 'volume-mute';
    if (this.volume < 0.5) return 'volume-low';
    return 'volume-medium';
  }

  toggleSpeedMenu() {
    this.onMouseMove();
    this.showSpeedMenu = !this.showSpeedMenu;
  }

  setPlaybackSpeed(speed: number) {
    this.onMouseMove();
    this.playbackSpeed = speed;
    this.videoElement.nativeElement.playbackRate = speed;
    this.showSpeedMenu = false;
  }

  onVideoEnded(): void {
    const currentTime: any = this.videoElement.nativeElement.currentTime;
    this.isPlaying = false;
    this.videoEnded.emit(currentTime);
  }

  onVideoPaused() {
    // console.log("onVideoPaused!")
    const currentTime = this.videoElement.nativeElement.currentTime;
    this.isPlaying = false;
    this.videoPaused.emit(currentTime);
  }

  // Callback cuando entra a fullscreen en iOS
  onEnterFullscreen(): void {
    this.isfullscren = true;
  }

  // Callback cuando sale de fullscreen en iOS
  onExitFullscreen(): void {
    this.isfullscren = false;

    // Sincronizar el estado de reproducción después de salir de fullscreen
    setTimeout(() => {
      const video = this.videoElement.nativeElement;
      this.isPlaying = !video.paused;
      const currentTime = video.currentTime;
      this.isPlaying ? this.videoPlaying.emit() : this.videoPaused.emit(currentTime);
    }, 100);
  }

  // Callback cuando el video empieza a reproducirse
  onVideoPlay(): void {
    this.isPlaying = true;
    this.videoPlaying.emit();
  }

  // Callback cuando el video se pausa
  onVideoPause(): void {
    this.isPlaying = false;
    const currentTime = this.videoElement.nativeElement.currentTime;
    this.videoPaused.emit(currentTime);
  }




}
